var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('GitHubCorner',{attrs:{"repo":"https://github.com/teal-language/teal-playground"}}),_c('Storage',{attrs:{"type":"localStorage"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var load = ref.load;
var save = ref.save;
return [_c('Playground',{attrs:{"initialData":load},on:{"input":save}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }